<template>
  <div class="hnYfKqAmountOrderList">
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.field === 'contractCurrency'">
              {{ currencyList[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    name: 'hnYfKqAmountOrderList',
    mixins: [tableMixins],
    components: {},
    data() {
      return {
        currencyList: [], // 币种数据
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'supplierNo', title: 'creditStatistics.table.supplierNo', visible: true },
          { field: 'supplierName', title: 'creditStatistics.table.supplierName', visible: true },
          { field: 'contractNo', title: 'creditStatistics.table.contractNo', visible: true },
          { field: 'tradeTypeName', title: 'creditStatistics.table.tradeTypeName', visible: true },
          {
            field: 'contractBusinessDepartmentName',
            title: 'creditStatistics.table.contractBusinessDepartmentName',
            visible: true,
          },
          {
            field: 'contractCurrency',
            title: 'creditStatistics.table.contractCurrencyName',
            visible: true,
          },
          {
            field: 'unpaidAmount',
            title: 'creditStatistics.table.unpaidAmount',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'unpaidCNYAmount',
            title: 'creditStatistics.table.unpaidCNYAmount',
            visible: true,
            format: 'formatAmountRound',
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getCurrency();
      this.getButtonList();
      this.getData();
    },
    methods: {
      //币别
      async getCurrency() {
        let res = await this.$baseRequest.getCurrency();
        if (res) {
          //this.currencyList = res;
          for (var item of res) {
            this.currencyList[item['currencyCode']] = item['currencyName'];
          }
        }
      },
      //获取数据
      getData() {
        this.load = true;
        this.$axios.get(API.HNYFKQAMOUNTORDER_LIST_API + '/' + this.$route.query.id).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data || [];
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
